import { BrowserRouter, Route, Routes } from "react-router-dom";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import HomePageOne from "./pages/HomePageOne";
import HomePageTwo from "./pages/HomePageTwo";
import HomePageThree from "./pages/HomePageThree";
import ShopPage from "./pages/ShopPage";
import ProductDetailsPageOne from "./pages/ProductDetailsPageOne";
import ProductDetailsPageTwo from "./pages/ProductDetailsPageTwo";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import AccountPage from "./pages/AccountPage";
import BlogPage from "./pages/BlogPage";
import BlogDetailsPage from "./pages/BlogDetailsPage";
import ContactPage from "./pages/ContactPage";
import PhosphorIconInit from "./helper/PhosphorIconInit";
import VendorPage from "./pages/VendorPage";
import VendorDetailsPage from "./pages/VendorDetailsPage";
import VendorTwoPage from "./pages/VendorTwoPage";
import VendorTwoDetailsPage from "./pages/VendorTwoDetailsPage";
import BecomeSellerPage from "./pages/BecomeSellerPage";
import WishlistPage from "./pages/WishlistPage";
import { UserProvider } from "./context/UserContext";
import PendingSellers from "./pages/admin/PendingSellers";
import SellerDashboard from "./pages/seller/Dashboard";
import ForgotPassword from "./pages/ForgotPassword";
import AdminLogin from './pages/AdminLogin';
import PartnerLogin from './pages/PartnerLogin';
import PartnerDashboard from './pages/partner/Dashboard';
import SellerRegistrationPage from './pages/SellerRegistrationPage';

// 👇 NEW ADMIN IMPORTS
import AdminLayout from './pages/admin/AdminLayout';
import AdminDashboard from './pages/admin/Dashboard';
import SellersPage from './pages/admin/Sellers';
// Import other admin pages as you create them
// import AdminOrders from './pages/admin/Orders';
// import AdminProducts from './pages/admin/Products';
// import AdminCustomers from './pages/admin/Customers';

function App() {
  return (
    <BrowserRouter>
      <UserProvider>
        <RouteScrollToTop />
        <PhosphorIconInit />
        <Routes>
          {/* Public Routes */}
          <Route exact path="/" element={<HomePageOne />} />
          <Route exact path="/index-two" element={<HomePageTwo />} />
          <Route exact path="/index-three" element={<HomePageThree />} />
          <Route exact path="/shop" element={<ShopPage />} />
          <Route exact path="/product-details" element={<ProductDetailsPageOne />} />
          <Route exact path="/product-details-two" element={<ProductDetailsPageTwo />} />
          <Route exact path="/cart" element={<CartPage />} />
          <Route exact path="/checkout" element={<CheckoutPage />} />
          <Route exact path="/wishlist" element={<WishlistPage />} />
          <Route exact path="/account" element={<AccountPage />} />
          <Route exact path="/blog" element={<BlogPage />} />
          <Route exact path="/blog-details" element={<BlogDetailsPage />} />
          <Route exact path="/contact" element={<ContactPage />} />
          <Route exact path="/vendor" element={<VendorPage />} />
          <Route exact path="/vendor-details" element={<VendorDetailsPage />} />
          <Route exact path="/vendor-two" element={<VendorTwoPage />} />
          <Route exact path="/vendor-two-details" element={<VendorTwoDetailsPage />} />
          
          {/* Seller Routes */}
          <Route exact path="/become-seller" element={<BecomeSellerPage />} />
          <Route exact path="/seller/register" element={<SellerRegistrationPage />} />
          <Route exact path="/seller/dashboard" element={<SellerDashboard />} />
          
          {/* Admin Login (No Layout) */}
          <Route exact path="/admin/login" element={<AdminLogin />} />
          
          {/* 👇 NEW ADMIN ROUTES WITH LAYOUT */}
          <Route exact path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="sellers" element={<SellersPage />} />
            <Route path="dashboard" element={<AdminDashboard />} />
            {/* Add more admin routes as you create them */}
            {/* <Route path="orders" element={<AdminOrders />} /> */}
            {/* <Route path="products" element={<AdminProducts />} /> */}
            {/* <Route path="customers" element={<AdminCustomers />} /> */}
          </Route>
          
          {/* Keep your existing admin route if needed (optional) */}
          <Route exact path="/admin/sellers/pending" element={<PendingSellers />} />
          
          {/* Partner Routes */}
          <Route exact path="/partner/login" element={<PartnerLogin />} />
          <Route exact path="/partner/dashboard" element={<PartnerDashboard />} />
          
          {/* Other Routes */}
          <Route exact path="/forgot-password" element={<ForgotPassword />} />
        </Routes>
      </UserProvider>
    </BrowserRouter>
  );
}

export default App;